import { ReactElement, useEffect, useRef } from 'react';

import { EmailAddress } from '@dreryk/email-address-common-api';

import { AppointmentRequestsSettingsFormController } from './AppointmentRequestsSettingsForm.types';
import { AllowAppointmentRequestsField } from './fields/AllowAppointmentRequestsField';
import { AppointmentRequestsEmailField } from './fields/AppointmentRequestsEmailField';
import { BlockShortAdvanceBookingField } from './fields/BlockShortAdvanceBookingField';
import { AllowCustomAppointmentRequestsField } from './fields/AllowCustomAppointmentRequestsField';

type AppointmentRequestsSettingsFieldsProps = Readonly<
   Pick<AppointmentRequestsSettingsFormController, 'register' | 'watch'> & {
      defaultAppointmentRequestsEmail: EmailAddress | null;
   }
>;

export const AppointmentRequestsSettingsFields = (props: AppointmentRequestsSettingsFieldsProps): ReactElement => {
   const {
      allowAppointmentRequests: currentAllowAppointmentRequests,
      allowCustomAppointmentRequests: currentAllowCustomAppointmentRequests,
      appointmentRequestsEmail: currentAppointmentRequestsEmail,
   } = props.watch(['allowAppointmentRequests', 'allowCustomAppointmentRequests', 'appointmentRequestsEmail']);
   const appointmentRequestsEmailRef = useRef<EmailAddress | null>(currentAppointmentRequestsEmail);

   useEffect(() => {
      appointmentRequestsEmailRef.current = currentAppointmentRequestsEmail;
   }, [currentAppointmentRequestsEmail]);

   return (
      <>
         <BlockShortAdvanceBookingField register={props.register} watch={props.watch} />
         <AllowAppointmentRequestsField register={props.register} />
         <AllowCustomAppointmentRequestsField register={props.register} />
         {currentAllowAppointmentRequests || currentAllowCustomAppointmentRequests ? (
            <AppointmentRequestsEmailField
               register={props.register}
               defaultValue={props.defaultAppointmentRequestsEmail ?? appointmentRequestsEmailRef.current}
            />
         ) : null}
      </>
   );
};
